import { useEffect } from 'react';
import { registerTools } from './runtime';

/**
 * Register a set of WebMCP tools for as long as this component is mounted.
 *
 * `tools` is rebuilt on every render, so the dependency is `key` — a string
 * describing the page state the tools belong to. That keeps registration
 * churn down: navigating within the marketplace should not tear down and
 * re-register the same three search tools on every keystroke.
 */
export function useWebMcp(key, buildTools) {
  useEffect(() => {
    let tools = [];
    try {
      tools = buildTools() || [];
    } catch (err) {
      console.warn('[webmcp] could not build tools for', key, err && err.message);
      return undefined;
    }
    if (!tools.length) return undefined;
    return registerTools(tools);
    // buildTools is intentionally not a dependency: it is a fresh closure each
    // render, and `key` is the real signal that the tool set should change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}
